import { setTableCSVExportWindowIsShown, setTableEXCELExportWindowIsShown, setTableInfoWindowIsShown, setTablePDFExportWindowIsShown } from "../../../../stateManagement/reducers/ContentHeaderSlice";
import { store } from "../../../../stateManagement/store";

export function controlShowTableInfoWindowButton(){
    const tableInfoWindowIsShown = store.getState().contentHeader.tableInfoWindowIsShown
    store.dispatch(setTableInfoWindowIsShown(!tableInfoWindowIsShown))
}

export function controlShowTablePDFExportWindowButton(){
    const tablePDFExportWindowIsShown = store.getState().contentHeader.tablePDFExportWindowIsShown
    store.dispatch(setTablePDFExportWindowIsShown(!tablePDFExportWindowIsShown))
}

export function controlShowTableCSVExportWindowButton(){
    const tableCSVExportWindowIsShown = store.getState().contentHeader.tableCSVExportWindowIsShown
    store.dispatch(setTableCSVExportWindowIsShown(!tableCSVExportWindowIsShown))
}

export function controlShowTableEXCELExportWindowButton(){
    const tableEXCELExportWindowIsShown = store.getState().contentHeader.tableEXCELExportWindowIsShown
    store.dispatch(setTableEXCELExportWindowIsShown(!tableEXCELExportWindowIsShown))
}

export function controlDiagnosticsMeasureResultsFilterButton(navigate: any){
    navigate('/app/diagnostics/diagnosticsMeasureResults/filters')
}